import { render, staticRenderFns } from "./DeviceBatteryPower.vue?vue&type=template&id=b462cc12&scoped=true"
import script from "./DeviceBatteryPower.vue?vue&type=script&lang=js"
export * from "./DeviceBatteryPower.vue?vue&type=script&lang=js"
import style0 from "./DeviceBatteryPower.vue?vue&type=style&index=0&id=b462cc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b462cc12",
  null
  
)

export default component.exports